export enum UploadTypeEnum {
  FormInstanceImage = 1,
  CompanyOfflineLogo = 2,
  CompanyOnlineLogo = 3,
  ReportTemplate = 4,
  SurveyPackTemplate = 5,
  QuestionIcon = 6,
  CompanyBackgroundImage = 7,
  QuestionFile = 8,
}
